import type { PaginaContext, PosicionContext, PublishedPageContext, SeleccionPayload, UiContextPayload } from './types';

export const UI_CONTEXT_MAX_CARAVANAS = 20000;

function seleccionPayload(sel: NonNullable<PublishedPageContext['seleccion']>, now: number): SeleccionPayload | undefined {
  const cambiada_hace_s = Math.max(0, Math.floor((now - sel.changedAt) / 1000));
  if (!sel.caravanas.length) {
    return sel.filtros_activos ? { origen: sel.origen, filtros_activos: sel.filtros_activos } : undefined;
  }
  if (sel.caravanas.length > UI_CONTEXT_MAX_CARAVANAS) {
    return { origen: sel.origen, total: sel.caravanas.length, ...(sel.filtros_activos ? { filtros_activos: sel.filtros_activos } : {}), cambiada_hace_s };
  }
  return { origen: sel.origen, caravanas: sel.caravanas, cambiada_hace_s };
}

/** Arma el uiContext del envío. Puro: el provider le pasa lo que tiene en el momento. */
export function buildUiContextSnapshot({ pagina, published, posicion, now = Date.now() }: {
  pagina?: PaginaContext;
  published?: PublishedPageContext;
  posicion?: PosicionContext | null;
  now?: number;
}): UiContextPayload | undefined {
  const out: UiContextPayload = {};
  if (pagina) out.pagina = pagina;
  if (published) {
    const { seleccion, ...rest } = published;
    for (const [k, v] of Object.entries(rest)) if (v !== undefined && v !== null) (out as Record<string, unknown>)[k] = v;
    if (seleccion) {
      const s = seleccionPayload(seleccion, now);
      if (s) out.seleccion = s;
    }
  }
  if (posicion) out.posicion = posicion;
  return Object.keys(out).length ? out : undefined;
}
